const INITIAL_STATE = {
  atual: "/"
};

export default (state = INITIAL_STATE, action) => {
  switch(action.type){
    case "CAMINHO_ATUAL":
      return {...state, atual: action.caminho};
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/CaminhoReducer.js